import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { PortalProfile } from '../../common-features/user-profile/user-profile.model';
import { ResetPassword } from '../../common-features/forget-password/forget-password.model';
import { ChangePassword } from '../../common-features/change-password/change-password.model';



@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpServices) { }


    register(user: User) {
        return this.http.post('Account/Register', user);
    }

    CompleteAccount(portalProfile: PortalProfile) {
        return this.http.post('Account/CompleteAccount',portalProfile);
    }

    SendResetPassword(userName: string) {
        return this.http.get('Account/SendResetPassword?UserName='+userName);
    }

    ResetPassword(resetPassword: ResetPassword) {
        return this.http.post('Account/ResetPassword',resetPassword);
    }
    ChangePassword(changePassword: ChangePassword) {
        return this.http.post('Account/ChangePassword',changePassword);
    }

    ResetActivation(userName: string) {
        return this.http.get('Account/ResendActivation?UserName='+userName);
    }
    ResendResetMail(userName: string) {
        return this.http.get('Account/ResendResetMail?UserName='+userName);
    }
    
    CheckCodeValid(userName: string,code: string) {
        return this.http.get('Account/CheckCodeValid?UserName='+userName+'&Code='+code);
    }
    RemoveLock(userName: string) {
        return this.http.get('Account/RemoveLock?UserName='+userName);
    }
    ConfirmAccount(ConfirmationCode: string) {
        return this.http.get('Account/ConfirmAccount?ConfirmationCode='+ConfirmationCode);
    }
    ActivateAccount(ConfirmationCode: string) {
        return this.http.get('Account/ActivateAccount?ActivationCode='+ConfirmationCode);
    }
    ResendAgentActivation(userName: string) {
        return this.http.get('Account/ResendAgentActivation?UserName='+userName);
    }
    ResendSupplierActivation(userName: string) {
        return this.http.get('Account/ResendSupplierActivation?UserName=' + userName);
    }
}